module.exports = __webpack_public_path__ + "media/application/images/partners/unesco@2x-2b310c65700136dbd5ca566390ea985f63bc55620bdcea32fb7ed3dfb9ab8ebc.png";